/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApplyBatesToDocuments200,
  ApplyBatesToDocumentsBody,
  BadRequestResponse,
  CompleteMultipartUpload200,
  CompleteMultipartUploadBody,
  ConflictResponse,
  DocumentPipelineStatistics,
  ForbiddenResponse,
  GetMultipartPartUrl200,
  GetMultipartPartUrlBody,
  GetOrganizationArchivedDocuments200,
  GetOrganizationArchivedDocumentsParams,
  GetOrganizationDocuments200,
  GetOrganizationDocumentsParams,
  GetPageTextContent200,
  GetPageTextContent404,
  GetTextBoundingBoxes200,
  GetTextBoundingBoxesBody,
  InternalServerErrorResponse,
  NotFoundResponse,
  RemoveBatesFromDocuments200,
  RemoveBatesFromDocumentsBody,
  ReprocessPageContent200,
  ReprocessPageContent400,
  ReprocessPageContent404,
  RestartDocumentPipeline200,
  RestartDocumentPipelineBody,
  RestartDocumentPipelineParams,
  SearchDocumentPages200,
  SearchDocumentPagesBody,
  StartDocumentPipeline200,
  StartMultipartUpload200,
  StartMultipartUploadBody,
  TextSnip200,
  TextSnipBody,
  UnauthorizedResponse,
  UpdateBatesStatus200,
  UpdateBatesStatusBody
} from '../model';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Initiate S3 multipart upload
 */
export const startMultipartUpload = (
    organizationId: string,
    projectId: string,
    uploadId: string,
    startMultipartUploadBody: StartMultipartUploadBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<StartMultipartUpload200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/uploads/${uploadId}/multipart/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startMultipartUploadBody, signal
    },
      options);
    }




export const getStartMultipartUploadMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMultipartUpload>>, TError,{organizationId: string;projectId: string;uploadId: string;data: StartMultipartUploadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startMultipartUpload>>, TError,{organizationId: string;projectId: string;uploadId: string;data: StartMultipartUploadBody}, TContext> => {

const mutationKey = ['startMultipartUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startMultipartUpload>>, {organizationId: string;projectId: string;uploadId: string;data: StartMultipartUploadBody}> = (props) => {
          const {organizationId,projectId,uploadId,data} = props ?? {};

          return  startMultipartUpload(organizationId,projectId,uploadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartMultipartUploadMutationResult = NonNullable<Awaited<ReturnType<typeof startMultipartUpload>>>
    export type StartMultipartUploadMutationBody = StartMultipartUploadBody
    export type StartMultipartUploadMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Initiate S3 multipart upload
 */
export const useStartMultipartUpload = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMultipartUpload>>, TError,{organizationId: string;projectId: string;uploadId: string;data: StartMultipartUploadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startMultipartUpload>>,
        TError,
        {organizationId: string;projectId: string;uploadId: string;data: StartMultipartUploadBody},
        TContext
      > => {
      return useMutation(getStartMultipartUploadMutationOptions(options), queryClient);
    }
    /**
 * @summary Get a presigned URL for a specific multipart part
 */
export const getMultipartPartUrl = (
    organizationId: string,
    projectId: string,
    uploadId: string,
    getMultipartPartUrlBody: GetMultipartPartUrlBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetMultipartPartUrl200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/uploads/${uploadId}/multipart/part-url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getMultipartPartUrlBody, signal
    },
      options);
    }




export const getGetMultipartPartUrlMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMultipartPartUrl>>, TError,{organizationId: string;projectId: string;uploadId: string;data: GetMultipartPartUrlBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getMultipartPartUrl>>, TError,{organizationId: string;projectId: string;uploadId: string;data: GetMultipartPartUrlBody}, TContext> => {

const mutationKey = ['getMultipartPartUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getMultipartPartUrl>>, {organizationId: string;projectId: string;uploadId: string;data: GetMultipartPartUrlBody}> = (props) => {
          const {organizationId,projectId,uploadId,data} = props ?? {};

          return  getMultipartPartUrl(organizationId,projectId,uploadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetMultipartPartUrlMutationResult = NonNullable<Awaited<ReturnType<typeof getMultipartPartUrl>>>
    export type GetMultipartPartUrlMutationBody = GetMultipartPartUrlBody
    export type GetMultipartPartUrlMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Get a presigned URL for a specific multipart part
 */
export const useGetMultipartPartUrl = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMultipartPartUrl>>, TError,{organizationId: string;projectId: string;uploadId: string;data: GetMultipartPartUrlBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getMultipartPartUrl>>,
        TError,
        {organizationId: string;projectId: string;uploadId: string;data: GetMultipartPartUrlBody},
        TContext
      > => {
      return useMutation(getGetMultipartPartUrlMutationOptions(options), queryClient);
    }
    /**
 * @summary Complete S3 multipart upload
 */
export const completeMultipartUpload = (
    organizationId: string,
    projectId: string,
    uploadId: string,
    completeMultipartUploadBody: CompleteMultipartUploadBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CompleteMultipartUpload200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/uploads/${uploadId}/multipart/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeMultipartUploadBody, signal
    },
      options);
    }




export const getCompleteMultipartUploadMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeMultipartUpload>>, TError,{organizationId: string;projectId: string;uploadId: string;data: CompleteMultipartUploadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeMultipartUpload>>, TError,{organizationId: string;projectId: string;uploadId: string;data: CompleteMultipartUploadBody}, TContext> => {

const mutationKey = ['completeMultipartUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeMultipartUpload>>, {organizationId: string;projectId: string;uploadId: string;data: CompleteMultipartUploadBody}> = (props) => {
          const {organizationId,projectId,uploadId,data} = props ?? {};

          return  completeMultipartUpload(organizationId,projectId,uploadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteMultipartUploadMutationResult = NonNullable<Awaited<ReturnType<typeof completeMultipartUpload>>>
    export type CompleteMultipartUploadMutationBody = CompleteMultipartUploadBody
    export type CompleteMultipartUploadMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Complete S3 multipart upload
 */
export const useCompleteMultipartUpload = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeMultipartUpload>>, TError,{organizationId: string;projectId: string;uploadId: string;data: CompleteMultipartUploadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeMultipartUpload>>,
        TError,
        {organizationId: string;projectId: string;uploadId: string;data: CompleteMultipartUploadBody},
        TContext
      > => {
      return useMutation(getCompleteMultipartUploadMutationOptions(options), queryClient);
    }
    /**
 * @summary Start the pipeline for a document
 */
export const startDocumentPipeline = (
    organizationId: string,
    projectId: string,
    documentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<StartDocumentPipeline200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}/pipeline`, method: 'POST', signal
    },
      options);
    }




export const getStartDocumentPipelineMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDocumentPipeline>>, TError,{organizationId: string;projectId: string;documentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startDocumentPipeline>>, TError,{organizationId: string;projectId: string;documentId: string}, TContext> => {

const mutationKey = ['startDocumentPipeline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startDocumentPipeline>>, {organizationId: string;projectId: string;documentId: string}> = (props) => {
          const {organizationId,projectId,documentId} = props ?? {};

          return  startDocumentPipeline(organizationId,projectId,documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartDocumentPipelineMutationResult = NonNullable<Awaited<ReturnType<typeof startDocumentPipeline>>>

    export type StartDocumentPipelineMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Start the pipeline for a document
 */
export const useStartDocumentPipeline = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDocumentPipeline>>, TError,{organizationId: string;projectId: string;documentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startDocumentPipeline>>,
        TError,
        {organizationId: string;projectId: string;documentId: string},
        TContext
      > => {
      return useMutation(getStartDocumentPipelineMutationOptions(options), queryClient);
    }
    /**
 * @summary Get the text content of a specific page
 */
export const getPageTextContent = (
    organizationId: string,
    projectId: string,
    pageId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetPageTextContent200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/pages/${pageId}/content`, method: 'GET', signal
    },
      options);
    }




export const getGetPageTextContentQueryKey = (organizationId: string,
    projectId: string,
    pageId: string,) => {
    return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/pages/${pageId}/content`
    ] as const;
    }


export const getGetPageTextContentQueryOptions = <TData = Awaited<ReturnType<typeof getPageTextContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetPageTextContent404 | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageTextContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageTextContentQueryKey(organizationId,projectId,pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageTextContent>>> = ({ signal }) => getPageTextContent(organizationId,projectId,pageId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && projectId !== null && projectId !== undefined && pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPageTextContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPageTextContentQueryResult = NonNullable<Awaited<ReturnType<typeof getPageTextContent>>>
export type GetPageTextContentQueryError = UnauthorizedResponse | ForbiddenResponse | GetPageTextContent404 | InternalServerErrorResponse


export function useGetPageTextContent<TData = Awaited<ReturnType<typeof getPageTextContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetPageTextContent404 | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    pageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageTextContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPageTextContent>>,
          TError,
          Awaited<ReturnType<typeof getPageTextContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageTextContent<TData = Awaited<ReturnType<typeof getPageTextContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetPageTextContent404 | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageTextContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPageTextContent>>,
          TError,
          Awaited<ReturnType<typeof getPageTextContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageTextContent<TData = Awaited<ReturnType<typeof getPageTextContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetPageTextContent404 | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageTextContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the text content of a specific page
 */

export function useGetPageTextContent<TData = Awaited<ReturnType<typeof getPageTextContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetPageTextContent404 | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageTextContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPageTextContentQueryOptions(organizationId,projectId,pageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Re-extracts the text content from a page using the Gemini AI model and updates the stored markdown content in S3.
 * @summary Reprocess page content using AI
 */
export const reprocessPageContent = (
    organizationId: string,
    projectId: string,
    pageId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ReprocessPageContent200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/pages/${pageId}/reprocess`, method: 'POST', signal
    },
      options);
    }




export const getReprocessPageContentMutationOptions = <TError = ReprocessPageContent400 | UnauthorizedResponse | ForbiddenResponse | ReprocessPageContent404 | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocessPageContent>>, TError,{organizationId: string;projectId: string;pageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reprocessPageContent>>, TError,{organizationId: string;projectId: string;pageId: string}, TContext> => {

const mutationKey = ['reprocessPageContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reprocessPageContent>>, {organizationId: string;projectId: string;pageId: string}> = (props) => {
          const {organizationId,projectId,pageId} = props ?? {};

          return  reprocessPageContent(organizationId,projectId,pageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReprocessPageContentMutationResult = NonNullable<Awaited<ReturnType<typeof reprocessPageContent>>>

    export type ReprocessPageContentMutationError = ReprocessPageContent400 | UnauthorizedResponse | ForbiddenResponse | ReprocessPageContent404 | InternalServerErrorResponse

    /**
 * @summary Reprocess page content using AI
 */
export const useReprocessPageContent = <TError = ReprocessPageContent400 | UnauthorizedResponse | ForbiddenResponse | ReprocessPageContent404 | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocessPageContent>>, TError,{organizationId: string;projectId: string;pageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reprocessPageContent>>,
        TError,
        {organizationId: string;projectId: string;pageId: string},
        TContext
      > => {
      return useMutation(getReprocessPageContentMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive a document
 */
export const archiveDocument = (
    organizationId: string,
    projectId: string,
    documentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}/archive`, method: 'POST', signal
    },
      options);
    }




export const getArchiveDocumentMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDocument>>, TError,{organizationId: string;projectId: string;documentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveDocument>>, TError,{organizationId: string;projectId: string;documentId: string}, TContext> => {

const mutationKey = ['archiveDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveDocument>>, {organizationId: string;projectId: string;documentId: string}> = (props) => {
          const {organizationId,projectId,documentId} = props ?? {};

          return  archiveDocument(organizationId,projectId,documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof archiveDocument>>>

    export type ArchiveDocumentMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Archive a document
 */
export const useArchiveDocument = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDocument>>, TError,{organizationId: string;projectId: string;documentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveDocument>>,
        TError,
        {organizationId: string;projectId: string;documentId: string},
        TContext
      > => {
      return useMutation(getArchiveDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary Apply Bates numbers to the selected documents
 */
export const applyBatesToDocuments = (
    organizationId: string,
    projectId: string,
    applyBatesToDocumentsBody: ApplyBatesToDocumentsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ApplyBatesToDocuments200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/apply-bates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: applyBatesToDocumentsBody, signal
    },
      options);
    }




export const getApplyBatesToDocumentsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyBatesToDocuments>>, TError,{organizationId: string;projectId: string;data: ApplyBatesToDocumentsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof applyBatesToDocuments>>, TError,{organizationId: string;projectId: string;data: ApplyBatesToDocumentsBody}, TContext> => {

const mutationKey = ['applyBatesToDocuments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyBatesToDocuments>>, {organizationId: string;projectId: string;data: ApplyBatesToDocumentsBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  applyBatesToDocuments(organizationId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyBatesToDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof applyBatesToDocuments>>>
    export type ApplyBatesToDocumentsMutationBody = ApplyBatesToDocumentsBody
    export type ApplyBatesToDocumentsMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Apply Bates numbers to the selected documents
 */
export const useApplyBatesToDocuments = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyBatesToDocuments>>, TError,{organizationId: string;projectId: string;data: ApplyBatesToDocumentsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyBatesToDocuments>>,
        TError,
        {organizationId: string;projectId: string;data: ApplyBatesToDocumentsBody},
        TContext
      > => {
      return useMutation(getApplyBatesToDocumentsMutationOptions(options), queryClient);
    }
    /**
 * @summary Skip Bates stamping or dismiss a detection hint for documents
 */
export const updateBatesStatus = (
    organizationId: string,
    projectId: string,
    updateBatesStatusBody: UpdateBatesStatusBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UpdateBatesStatus200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/bates-status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateBatesStatusBody, signal
    },
      options);
    }




export const getUpdateBatesStatusMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBatesStatus>>, TError,{organizationId: string;projectId: string;data: UpdateBatesStatusBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBatesStatus>>, TError,{organizationId: string;projectId: string;data: UpdateBatesStatusBody}, TContext> => {

const mutationKey = ['updateBatesStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBatesStatus>>, {organizationId: string;projectId: string;data: UpdateBatesStatusBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  updateBatesStatus(organizationId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBatesStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateBatesStatus>>>
    export type UpdateBatesStatusMutationBody = UpdateBatesStatusBody
    export type UpdateBatesStatusMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Skip Bates stamping or dismiss a detection hint for documents
 */
export const useUpdateBatesStatus = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBatesStatus>>, TError,{organizationId: string;projectId: string;data: UpdateBatesStatusBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBatesStatus>>,
        TError,
        {organizationId: string;projectId: string;data: UpdateBatesStatusBody},
        TContext
      > => {
      return useMutation(getUpdateBatesStatusMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove Bates numbers from the selected documents
 */
export const removeBatesFromDocuments = (
    organizationId: string,
    projectId: string,
    removeBatesFromDocumentsBody: RemoveBatesFromDocumentsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RemoveBatesFromDocuments200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/remove-bates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: removeBatesFromDocumentsBody, signal
    },
      options);
    }




export const getRemoveBatesFromDocumentsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeBatesFromDocuments>>, TError,{organizationId: string;projectId: string;data: RemoveBatesFromDocumentsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeBatesFromDocuments>>, TError,{organizationId: string;projectId: string;data: RemoveBatesFromDocumentsBody}, TContext> => {

const mutationKey = ['removeBatesFromDocuments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeBatesFromDocuments>>, {organizationId: string;projectId: string;data: RemoveBatesFromDocumentsBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  removeBatesFromDocuments(organizationId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveBatesFromDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof removeBatesFromDocuments>>>
    export type RemoveBatesFromDocumentsMutationBody = RemoveBatesFromDocumentsBody
    export type RemoveBatesFromDocumentsMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Remove Bates numbers from the selected documents
 */
export const useRemoveBatesFromDocuments = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeBatesFromDocuments>>, TError,{organizationId: string;projectId: string;data: RemoveBatesFromDocumentsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeBatesFromDocuments>>,
        TError,
        {organizationId: string;projectId: string;data: RemoveBatesFromDocumentsBody},
        TContext
      > => {
      return useMutation(getRemoveBatesFromDocumentsMutationOptions(options), queryClient);
    }
    /**
 * @summary Get all documents for an organization
 */
export const getOrganizationDocuments = (
    organizationId: string,
    params?: GetOrganizationDocumentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetOrganizationDocuments200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/documents`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetOrganizationDocumentsQueryKey = (organizationId: string,
    params?: GetOrganizationDocumentsParams,) => {
    return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    params?: GetOrganizationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationDocumentsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationDocuments>>> = ({ signal }) => getOrganizationDocuments(organizationId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationDocuments>>>
export type GetOrganizationDocumentsQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetOrganizationDocuments<TData = Awaited<ReturnType<typeof getOrganizationDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: undefined |  GetOrganizationDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDocuments<TData = Awaited<ReturnType<typeof getOrganizationDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetOrganizationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDocuments<TData = Awaited<ReturnType<typeof getOrganizationDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetOrganizationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all documents for an organization
 */

export function useGetOrganizationDocuments<TData = Awaited<ReturnType<typeof getOrganizationDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetOrganizationDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationDocumentsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get all archived documents for an organization
 */
export const getOrganizationArchivedDocuments = (
    organizationId: string,
    params?: GetOrganizationArchivedDocumentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetOrganizationArchivedDocuments200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/archive/documents`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetOrganizationArchivedDocumentsQueryKey = (organizationId: string,
    params?: GetOrganizationArchivedDocumentsParams,) => {
    return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/archive/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationArchivedDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    params?: GetOrganizationArchivedDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationArchivedDocumentsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>> = ({ signal }) => getOrganizationArchivedDocuments(organizationId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationArchivedDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>>
export type GetOrganizationArchivedDocumentsQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetOrganizationArchivedDocuments<TData = Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: undefined |  GetOrganizationArchivedDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationArchivedDocuments<TData = Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetOrganizationArchivedDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationArchivedDocuments<TData = Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetOrganizationArchivedDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all archived documents for an organization
 */

export function useGetOrganizationArchivedDocuments<TData = Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetOrganizationArchivedDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationArchivedDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationArchivedDocumentsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get document pipeline processing statistics
 */
export const getPipelineStatistics = (
    organizationId: string,
    projectId: string,
    documentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DocumentPipelineStatistics>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}/pipeline/statistics`, method: 'GET', signal
    },
      options);
    }




export const getGetPipelineStatisticsQueryKey = (organizationId: string,
    projectId: string,
    documentId: string,) => {
    return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}/pipeline/statistics`
    ] as const;
    }


export const getGetPipelineStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getPipelineStatistics>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPipelineStatisticsQueryKey(organizationId,projectId,documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelineStatistics>>> = ({ signal }) => getPipelineStatistics(organizationId,projectId,documentId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && projectId !== null && projectId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPipelineStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPipelineStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelineStatistics>>>
export type GetPipelineStatisticsQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetPipelineStatistics<TData = Awaited<ReturnType<typeof getPipelineStatistics>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    documentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineStatistics>>,
          TError,
          Awaited<ReturnType<typeof getPipelineStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineStatistics<TData = Awaited<ReturnType<typeof getPipelineStatistics>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineStatistics>>,
          TError,
          Awaited<ReturnType<typeof getPipelineStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineStatistics<TData = Awaited<ReturnType<typeof getPipelineStatistics>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get document pipeline processing statistics
 */

export function useGetPipelineStatistics<TData = Awaited<ReturnType<typeof getPipelineStatistics>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStatistics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPipelineStatisticsQueryOptions(organizationId,projectId,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Restart the pipeline for a document
 */
export const restartDocumentPipeline = (
    organizationId: string,
    projectId: string,
    documentId: string,
    restartDocumentPipelineBody?: RestartDocumentPipelineBody,
    params?: RestartDocumentPipelineParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RestartDocumentPipeline200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}/pipeline/restart`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: restartDocumentPipelineBody,
        params, signal
    },
      options);
    }




export const getRestartDocumentPipelineMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restartDocumentPipeline>>, TError,{organizationId: string;projectId: string;documentId: string;data?: RestartDocumentPipelineBody;params?: RestartDocumentPipelineParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restartDocumentPipeline>>, TError,{organizationId: string;projectId: string;documentId: string;data?: RestartDocumentPipelineBody;params?: RestartDocumentPipelineParams}, TContext> => {

const mutationKey = ['restartDocumentPipeline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restartDocumentPipeline>>, {organizationId: string;projectId: string;documentId: string;data?: RestartDocumentPipelineBody;params?: RestartDocumentPipelineParams}> = (props) => {
          const {organizationId,projectId,documentId,data,params} = props ?? {};

          return  restartDocumentPipeline(organizationId,projectId,documentId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestartDocumentPipelineMutationResult = NonNullable<Awaited<ReturnType<typeof restartDocumentPipeline>>>
    export type RestartDocumentPipelineMutationBody = RestartDocumentPipelineBody | undefined
    export type RestartDocumentPipelineMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Restart the pipeline for a document
 */
export const useRestartDocumentPipeline = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restartDocumentPipeline>>, TError,{organizationId: string;projectId: string;documentId: string;data?: RestartDocumentPipelineBody;params?: RestartDocumentPipelineParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restartDocumentPipeline>>,
        TError,
        {organizationId: string;projectId: string;documentId: string;data?: RestartDocumentPipelineBody;params?: RestartDocumentPipelineParams},
        TContext
      > => {
      return useMutation(getRestartDocumentPipelineMutationOptions(options), queryClient);
    }
    /**
 * Performs keyword search within a single document's pages using OpenSearch. Returns matching pages with highlighted snippets.
 * @summary Search within a document's pages using keyword search
 */
export const searchDocumentPages = (
    organizationId: string,
    projectId: string,
    documentId: string,
    searchDocumentPagesBody: SearchDocumentPagesBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SearchDocumentPages200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchDocumentPagesBody, signal
    },
      options);
    }




export const getSearchDocumentPagesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDocumentPages>>, TError,{organizationId: string;projectId: string;documentId: string;data: SearchDocumentPagesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchDocumentPages>>, TError,{organizationId: string;projectId: string;documentId: string;data: SearchDocumentPagesBody}, TContext> => {

const mutationKey = ['searchDocumentPages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchDocumentPages>>, {organizationId: string;projectId: string;documentId: string;data: SearchDocumentPagesBody}> = (props) => {
          const {organizationId,projectId,documentId,data} = props ?? {};

          return  searchDocumentPages(organizationId,projectId,documentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchDocumentPagesMutationResult = NonNullable<Awaited<ReturnType<typeof searchDocumentPages>>>
    export type SearchDocumentPagesMutationBody = SearchDocumentPagesBody
    export type SearchDocumentPagesMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Search within a document's pages using keyword search
 */
export const useSearchDocumentPages = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDocumentPages>>, TError,{organizationId: string;projectId: string;documentId: string;data: SearchDocumentPagesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchDocumentPages>>,
        TError,
        {organizationId: string;projectId: string;documentId: string;data: SearchDocumentPagesBody},
        TContext
      > => {
      return useMutation(getSearchDocumentPagesMutationOptions(options), queryClient);
    }
    /**
 * Uses Gemini AI to detect and return bounding box coordinates for all occurrences of a search query text in a document page image. Coordinates are normalized to 0-1000 scale.
 * @summary Get bounding box coordinates for text occurrences in a page image
 */
export const getTextBoundingBoxes = (
    organizationId: string,
    projectId: string,
    pageId: string,
    getTextBoundingBoxesBody: GetTextBoundingBoxesBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetTextBoundingBoxes200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/pages/${pageId}/text-bounding-boxes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getTextBoundingBoxesBody, signal
    },
      options);
    }




export const getGetTextBoundingBoxesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTextBoundingBoxes>>, TError,{organizationId: string;projectId: string;pageId: string;data: GetTextBoundingBoxesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getTextBoundingBoxes>>, TError,{organizationId: string;projectId: string;pageId: string;data: GetTextBoundingBoxesBody}, TContext> => {

const mutationKey = ['getTextBoundingBoxes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTextBoundingBoxes>>, {organizationId: string;projectId: string;pageId: string;data: GetTextBoundingBoxesBody}> = (props) => {
          const {organizationId,projectId,pageId,data} = props ?? {};

          return  getTextBoundingBoxes(organizationId,projectId,pageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTextBoundingBoxesMutationResult = NonNullable<Awaited<ReturnType<typeof getTextBoundingBoxes>>>
    export type GetTextBoundingBoxesMutationBody = GetTextBoundingBoxesBody
    export type GetTextBoundingBoxesMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Get bounding box coordinates for text occurrences in a page image
 */
export const useGetTextBoundingBoxes = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTextBoundingBoxes>>, TError,{organizationId: string;projectId: string;pageId: string;data: GetTextBoundingBoxesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTextBoundingBoxes>>,
        TError,
        {organizationId: string;projectId: string;pageId: string;data: GetTextBoundingBoxesBody},
        TContext
      > => {
      return useMutation(getGetTextBoundingBoxesMutationOptions(options), queryClient);
    }
    /**
 * Accepts normalized rectangle coordinates, fetches the page image from S3 server-side, and sends it to Gemini for OCR extraction of the specified region.
 * @summary Extract text from a rectangular region of a document page
 */
export const textSnip = (
    organizationId: string,
    projectId: string,
    pageId: string,
    textSnipBody: TextSnipBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TextSnip200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/pages/${pageId}/text-snip`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: textSnipBody, signal
    },
      options);
    }




export const getTextSnipMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof textSnip>>, TError,{organizationId: string;projectId: string;pageId: string;data: TextSnipBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof textSnip>>, TError,{organizationId: string;projectId: string;pageId: string;data: TextSnipBody}, TContext> => {

const mutationKey = ['textSnip'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof textSnip>>, {organizationId: string;projectId: string;pageId: string;data: TextSnipBody}> = (props) => {
          const {organizationId,projectId,pageId,data} = props ?? {};

          return  textSnip(organizationId,projectId,pageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TextSnipMutationResult = NonNullable<Awaited<ReturnType<typeof textSnip>>>
    export type TextSnipMutationBody = TextSnipBody
    export type TextSnipMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Extract text from a rectangular region of a document page
 */
export const useTextSnip = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof textSnip>>, TError,{organizationId: string;projectId: string;pageId: string;data: TextSnipBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof textSnip>>,
        TError,
        {organizationId: string;projectId: string;pageId: string;data: TextSnipBody},
        TContext
      > => {
      return useMutation(getTextSnipMutationOptions(options), queryClient);
    }
